import {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

interface PartnerSignupRequest {
  name: string;
  email: string;
  phone_number: string;
}

interface PartnerSignupResponse {
  data: PartnerSignupRequest & {
    id: number;
  };
}

export const usePartnerSignupMutation = (
  options?: UseMutationOptions<PartnerSignupResponse, AxiosError, PartnerSignupRequest>,
) =>
  useMutation<PartnerSignupResponse, AxiosError, PartnerSignupRequest>(
    (params) => api.post('v3/partners', params),
    options,
  );
